import { useEffect } from 'react';
import { useRouter } from 'next/router';
import useNavigationURL from "../../hooks/useNavigationURL";

function CustomerRedirect() {
    const router = useRouter();
    const navigationURL = useNavigationURL();

    useEffect(() => {
        // Redirect to get-subscription-link page when accessing /customer
        router.replace(`${navigationURL}/get-subscription-link`);
    }, [router]);

    // Return null or a loading state while redirecting
    return null;
}

export default CustomerRedirect;